// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"704":"6538d0c6","949":"6538d0c6"}[chunkId] + ".chunk.css";
};